import './index.css';

export default {
  name: 'Atabs',
  props: {
    id: { type: String, default: () => (`a-tabs-${Math.random().toString().substring(2)}`) },
    data: {
      type: Array,
      default: () => [
        { label: '栏目一', value: '0' },
        { label: '栏目二', value: '1' },
      ]
    },
    items: { type: Array, default: () => null },
    config: { type: Array, default: () => null },
    option: { type: Array, default: () => null },
    options: { type: Array, default: () => null },
    flex: { type: Boolean, default: () => true },
  },
  data() {
    return {
      active: null,
    }
  },
  mounted() {
    this.relate();
  },
  methods: {
    relate() {
      this.$nextTick(() => this.active = '0');
    },
    create() {
      const { type = 'border-card', margin = '0', padding = '16px', ...attrs } = this.$attrs;
      const data = this.options || this.option || this.config || this.items || this.data || [];
      return (
        <el-tabs
          class={['a-tabs', (this.flex ? 'flex' : null)]}
          on-tab-click={this.change}
          v-model={this.active}
          style={{ margin }}
          id={this.id}
          type={type}
          {...{ attrs }}
        >
          {data.length > 0 && data.map((a, b) => {
            let label = a.text || a.name || a.label || a.title || `${a}`;
            let value = a.value || a.code || a.id || `${b}`;
            let image = a.img || a.icon || a.image;
            return (
              <el-tab-pane key={b} name={value} label={label} class={this.active == b ? 'active' : null} style={{ padding }}>
                {image && (<span slot="label"><i class={image} /> {label}</span>)}
                {this.active == value && (a.render ? a.render(a) : (<div key={b}>{this.$slots[label]}</div>))}
              </el-tab-pane>
            );
          })}
          {this.$slots.default}
        </el-tabs>
      );
    },
    change({ index }) {
      const { pageParams, formParams, selectedKeys, selectedRows } = this.$store.getState();
      this.$store.commit('setPageParams', pageParams);
      this.$store.commit('setFormParams', formParams);
      this.$store.commit('setSelectedKeys', selectedKeys);
      this.$store.commit('setSelectedRows', selectedRows);
      this.$nextTick(() => {
        this.active = index;
        this.$nextTick(() => {
          let data = ({ index, ...this.data[index] });
          this.$nextTick(() => {
            this.$emit('click', data);
            this.$emit('change', data);
            this.$emit('select', data);
          });
        });
      });
    },
  },
  render() {
    return this.create();
  }
}